'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconPlaybackSpeed2x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m13.56 10.383 1.97 1.97-1.06 1.06-1.97-1.97-1.97 1.97-1.06-1.06 1.97-1.97-1.97-1.97 1.06-1.06 1.97 1.969 1.97-1.97 1.06 1.06-1.97 1.97ZM.866 11.852A3.811 3.811 0 0 0 .578 13.5h7.424v-1.408H2.564a2.32 2.32 0 0 1 .254-.512c.17-.256.41-.523.72-.8.31-.288.72-.613 1.232-.976.779-.555 1.403-1.072 1.872-1.552.48-.49.827-.976 1.04-1.456.213-.48.32-.992.32-1.536 0-.597-.139-1.152-.416-1.664-.267-.512-.677-.923-1.232-1.232-.544-.32-1.21-.48-2-.48-.779 0-1.456.17-2.032.512A3.365 3.365 0 0 0 .994 3.868c-.299.63-.448 1.381-.448 2.256h1.52c0-.608.085-1.12.256-1.536.181-.416.443-.73.784-.944.352-.224.763-.336 1.232-.336.448 0 .827.09 1.136.272.32.17.555.41.704.72.16.299.24.635.24 1.008 0 .395-.085.773-.256 1.136-.17.363-.448.73-.832 1.104-.384.373-.896.784-1.536 1.232-.81.555-1.45 1.077-1.92 1.568-.459.49-.795.992-1.008 1.504Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m20.164 16.25 2.543-2.543-1.414-1.414-2.543 2.543-2.543-2.543-1.414 1.414 2.543 2.543-2.543 2.543 1.414 1.414 2.543-2.543 2.543 2.543 1.414-1.414-2.543-2.543ZM2.785 17.808a5.415 5.415 0 0 0-.414 2.346h10.626v-1.932H5.094a3.18 3.18 0 0 1 .359-.782c.245-.368.59-.76 1.035-1.173.46-.414 1.065-.882 1.817-1.403 1.134-.813 2.04-1.564 2.714-2.254.69-.706 1.188-1.403 1.495-2.093.306-.69.46-1.434.46-2.231 0-.844-.192-1.633-.575-2.37-.384-.735-.974-1.326-1.771-1.77-.782-.46-1.733-.69-2.852-.69-1.12 0-2.093.245-2.921.736-.813.49-1.442 1.196-1.886 2.116-.43.904-.644 1.978-.644 3.22h2.093c0-.874.13-1.618.39-2.231.261-.614.645-1.081 1.15-1.403.507-.322 1.105-.483 1.795-.483.66 0 1.219.13 1.679.39.46.261.805.614 1.035 1.059.23.444.345.943.345 1.495 0 .582-.13 1.142-.391 1.679-.246.52-.652 1.058-1.22 1.61-.551.536-1.295 1.134-2.23 1.794-1.15.797-2.063 1.548-2.737 2.254-.66.69-1.143 1.395-1.45 2.116Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed2x is deprecated and will be archived soon. Use IconPlaybackSpeed2x instead.
 */
export function Experimental__IconPlaybackSpeed2x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed2x, props);
}